// routes
import { PATH_AUTH } from '../routes/paths';

// ----------------------------------------------------------------------

/**
 * AF-03: Session is cookie-backed (httpOnly JWT).
 * Only non-secret association id may live in sessionStorage for UI helpers.
 */
export const setSession = (userId) => {
  sessionStorage.removeItem('accessToken');
  if (userId) {
    sessionStorage.setItem('userId', userId);
  } else {
    sessionStorage.removeItem('userId');
  }
};

export const clearClientSession = () => {
  sessionStorage.removeItem('accessToken');
  sessionStorage.removeItem('userId');
  sessionStorage.removeItem('devAccessToken');
};

export const redirectToLoginOnExpiry = () => {
  clearClientSession();
  window.location.href = PATH_AUTH.login;
};
